import { useState, useEffect } from "react";
import useQuestFetch from './hooks/useQuestFetch';
import LoadingIcon from "./CommonComponents/Animations/LoadingIcon";
import useMediaQuery from './hooks/useMediaQuery';
import { Button } from './CommonComponents/BaseComponents'

export default ({
  onSeasonSelected
}) => {
  const isSmallView = useMediaQuery('(max-width: 620px)');

  const fetch = useQuestFetch();

  const [selectedSeasonIndex, setSelectedSeasonIndex] = useState()

  const [isLoading, setIsLoading] = useState(true)

  const [seasonDetails, setSeasonDetails] = useState()

  const fetchQuestSeasons = async () => {
    setIsLoading(true)
    try {
      const response = await fetch(
        `season/allSeasonDetails`, 
        { 
          method: 'GET',
        }
      )
      const jsonData = await response.json() || {};
      setSeasonDetails(jsonData.data)
    } catch (e) {
      setSeasonDetails(undefined)
    }
    setIsLoading(false)
  }

  useEffect(() => {
    fetchQuestSeasons()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Our selector will only show Apex products for now
  const productType = 'Adventures Apex';

  // Logic replicated from Quest Portal
  const availableProducts = 
    productType === 'Adventures Apex' ?
    [101,102,103]
    :
    productType === 'Adventures Starforce' ?
    [201]
    :
    productType === 'Creators Primary' ?
    [301]
    :
    productType === 'Creators Intermediate' ?
    [302]
    :
    productType === 'Internal Test Codes' ?
    Object.keys(seasonDetails)
    :
    []

  const products = seasonDetails ? availableProducts.map((seasonDetailsKey) => {
    const seasonDetailsObj = seasonDetails[seasonDetailsKey] || {};
    const {
      season: {
        Name: seasonName,
        Physical_Box_Image__c,
        Season_Index__c
      } = {}
    } = seasonDetailsObj;

    const nameVal = seasonName;
    const image = Physical_Box_Image__c;

    return { name: nameVal, val: nameVal, image, seasonIndex: Season_Index__c }
  }) : []

  console.log(products)

  return (
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: isSmallView ? 'flex-start' : 'center',
        alignItems: 'center',
        padding: '20px',
        zIndex: '100',
        marginTop: isSmallView ? '-15px' : '0px'
      }}>
      {
        isLoading ?
        <LoadingIcon />
        :
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '40px', alignItems: 'center', justifyContent: 'center' }}>
          {
            products.map(({ name, image, seasonIndex }) => {
              return (
                <div
                  key={seasonIndex}
                  style={{
                    padding: '10px',
                    border: selectedSeasonIndex === seasonIndex ? "5px solid #ffc200" : "5px solid transparent",
                    borderRadius: '20px'
                  }}
                  onClick={() => selectedSeasonIndex === seasonIndex ? setSelectedSeasonIndex(undefined) : setSelectedSeasonIndex(seasonIndex)}
                >
                  <img
                    alt="season-select"
                    src={image}
                    width="224px"
                    height="216px"
                    style={{
                      borderRadius: "8px",
                      cursor: "pointer",
                    }}
                  />
                  <div style={{
                    fontSize: '22px',
                    fontWeight: 'bold',
                    color: '#ffc200',
                    marginTop: '15px'
                  }}>
                    {name}
                  </div>
                </div>
              )
            })
          }
        </div>
      }
      <div style={{ marginTop: '20px', display: 'flex', alignItems: 'center', justifyContent: isSmallView ? 'center' : 'center' }}>
        <Button 
          style={{ 
            display: 'inline-flex', 
            marginRight: '10px', 
            fontWeight: 'bold', 
            fontSize: '24px',
            width: '150px', 
            height: '40px',
            background: 'transparent'
          }} 
          onClick={() => onSeasonSelected(selectedSeasonIndex)} 
          $colored={true}
        >
          {'SUBMIT'}
        </Button>
      </div>
    </div>
  )
}